/* DANDY HATS — purchase-limit enforcement (Dawn / NEW THEME)
   Ported from the engine used on the last 2 sold-out drops.
   This drop: 3 per hat style, 1 per bundle. Bundle keyed by HANDLE (not numeric id).
   ─────────────────────────────────────────────────────────────────────────── */
(function () {
  console.log('%c[hat-cart-rules] v16 active — 3 per hat, 1 bundle + instant PDP + instant ATC + cache resync on qty change', 'color:#39ff14');
  const MAX_PER_TYPE = 3;                                  // hats: max 3 per style (per order)
  const BUNDLE_HANDLE = 'another-dandy-drop-bundle';       // bundle: max 1, excluded from hat total
  const ENFORCE_TOTAL = false;                             // set true to also cap total hats across styles
  const MAX_TOTAL = 6;                                     // only used when ENFORCE_TOTAL = true

  let cachedCart = null;

  // Max allowed for a given cart line item (bundle = 1, everything else = MAX_PER_TYPE)
  function maxFor(item) {
    return item && item.handle === BUNDLE_HANDLE ? 1 : MAX_PER_TYPE;
  }

  // Qty in cart for a given id/handle (matches product_id, variant_id, or handle)
  function getQtyInCart(cart, id) {
    if (!cart || !id) return 0;
    const key = String(id);
    return cart.items
      .filter(i => String(i.product_id) === key || String(i.variant_id) === key || i.handle === key)
      .reduce((sum, i) => sum + i.quantity, 0);
  }

  function hatTotal(cart) {
    return cart.items
      .filter(i => i.handle !== BUNDLE_HANDLE)
      .reduce((sum, i) => sum + i.quantity, 0);
  }

  // Current product handle from the page (PDP) — used to detect bundle on its own page
  function getPageHandle() {
    const m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  // Shopify-shaped 422 so Dawn handles both paths gracefully:
  //  • product-form.js checks `response.status` → handleErrorMessage(description)
  //  • cart.js (drawer +/- stepper) checks `parsedState.errors` → shows it + reverts qty
  function blockResponse(desc) {
    return Promise.resolve(new Response(
      JSON.stringify({ status: 422, message: 'Cart error', description: desc, errors: desc }),
      { status: 422, statusText: 'Unprocessable Entity', headers: { 'Content-Type': 'application/json' } }
    ));
  }

  // ─── CORE: clamp any over-limit line, skip nothing (bundle clamps to 1) ───
  function enforceCartRules(callback) {
    originalFetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        cachedCart = cart;
        const updates = {};
        let needsUpdate = false;
        let clampedBundle = false;

        cart.items.forEach(item => {
          const max = maxFor(item);
          if (item.quantity > max) {
            updates[item.key] = max;
            needsUpdate = true;
            if (item.handle === BUNDLE_HANDLE) clampedBundle = true;
          }
        });

        if (needsUpdate) {
          originalFetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          })
            .then(r => r.json())
            .then(updatedCart => {
              cachedCart = updatedCart;
              showToast(clampedBundle ? 'Only 1 bundle allowed.' : `Only ${MAX_PER_TYPE} per hat style allowed.`);
              if (callback) callback();
              applyUI(updatedCart);
            });
        } else {
          if (callback) callback();
          applyUI(cart);
        }
      });
  }

  // ─── INTERCEPT fetch ───
  const originalFetch = window.fetch;
  window.fetch = function (url, options) {
    // /cart/add — refuse over-limit. FAST PATH: pre-check against the maintained cachedCart so there's
    // NO network round-trip before the add fires (that round-trip was the click→drawer delay). Only when
    // the cache says we're already AT the limit do we fetch /cart.js to confirm before blocking (so we
    // never wrongly block on stale cache). The post-add clamp below still corrects any over-limit that
    // slips past a stale-low cache.
    if (typeof url === 'string' && url.includes('/cart/add')) {
      // Dawn's product page posts FormData (multipart); the drawer/JS posts JSON. Handle both.
      let addId = '';
      try {
        const b = options && options.body;
        if (b instanceof FormData) {
          addId = String(b.get('id') || '');
        } else if (typeof b === 'string') {
          const parsed = b.startsWith('{') ? JSON.parse(b) : Object.fromEntries(new URLSearchParams(b));
          addId = String(parsed.id || parsed.product_id || (parsed.items && parsed.items[0] && parsed.items[0].id) || '');
        }
      } catch (e) {}
      const pageHandle = getPageHandle();

      const isBundleFor = (cart) => pageHandle === BUNDLE_HANDLE
        || (cart && cart.items.some(i => i.handle === BUNDLE_HANDLE && (String(i.variant_id) === addId || String(i.product_id) === addId)));

      // Decide on a known cart, then add (or block). The post-add UI sync runs in parallel — it does NOT
      // delay the returned response, so Dawn opens the drawer as soon as the add itself resolves.
      const decideAndAdd = (cart) => {
        cachedCart = cart;
        const isBundle = isBundleFor(cart);
        const max = isBundle ? 1 : MAX_PER_TYPE;

        if (ENFORCE_TOTAL && !isBundle && hatTotal(cart) >= MAX_TOTAL) {
          showToast(`Max ${MAX_TOTAL} hats total.`);
          return blockResponse(`Max ${MAX_TOTAL} hats total.`);
        }
        if (addId && getQtyInCart(cart, addId) >= max) {
          const msg = isBundle ? 'Only 1 bundle allowed.' : `Only ${MAX_PER_TYPE} per hat style allowed.`;
          showToast(msg);
          return blockResponse(msg);
        }

        // Under limit — perform the real add, then sync UI (+ safety clamp for rapid double-clicks)
        return originalFetch(url, options).then(response => {
          originalFetch('/cart.js').then(r => r.json()).then(c => {
            cachedCart = c;
            const updates = {}; let needsUpdate = false; let clampedBundle = false;
            c.items.forEach(item => {
              const m = maxFor(item);
              if (item.quantity > m) { updates[item.key] = m; needsUpdate = true; if (item.handle === BUNDLE_HANDLE) clampedBundle = true; }
            });
            if (needsUpdate) {
              originalFetch('/cart/update.js', {
                method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates })
              }).then(r => r.json()).then(uc => {
                cachedCart = uc;
                showToast(clampedBundle ? 'Only 1 bundle allowed.' : `Only ${MAX_PER_TYPE} per hat style allowed.`);
                applyUI(uc); document.dispatchEvent(new CustomEvent('cart:updated'));
              });
            } else {
              applyUI(c); document.dispatchEvent(new CustomEvent('cart:updated'));
            }
          });
          return response;
        });
      };

      // Fast path: trust cachedCart when it says we're under the limit → add immediately, no pre-fetch.
      if (cachedCart) {
        const max = isBundleFor(cachedCart) ? 1 : MAX_PER_TYPE;
        const atLimit = addId && getQtyInCart(cachedCart, addId) >= max;
        if (!atLimit) return decideAndAdd(cachedCart);
        // Cache says at limit → confirm with an authoritative read before refusing.
        return originalFetch('/cart.js').then(r => r.json()).then(decideAndAdd);
      }
      // No cache yet (first action this page load) → one read, then decide.
      return originalFetch('/cart.js').then(r => r.json()).then(decideAndAdd);
    }

    // /cart/change — guard qty increases; never block removes (quantity: 0)
    if (typeof url === 'string' && url.includes('/cart/change')) {
      let body = {};
      try { body = JSON.parse((options && options.body) || '{}'); } catch (e) {}

      if (body.quantity === 0) {
        return originalFetch(url, options).then(response => {
          response.clone().json().then(cart => {
            cachedCart = cart;
            applyUI(cart);
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }).catch(() => {});
          return response;
        });
      }

      // Determine the max for the line being changed (Dawn sends `line` index; others send id/key)
      const items = (cachedCart && cachedCart.items) || [];
      const item = (body.line && items[body.line - 1]) || items.find(i => i.key === body.id || i.key === body.key) || null;
      const lineMax = item ? maxFor(item) : MAX_PER_TYPE;

      if (body.quantity > lineMax) {
        const msg = lineMax === 1 ? 'Only 1 bundle allowed.' : `Only ${MAX_PER_TYPE} per hat style allowed.`;
        showToast(msg);
        return blockResponse(msg);
      }

      // Run the change, then refresh cachedCart from the response. The drawer qty stepper goes through
      // here — WITHOUT this resync, raising a line to its max, closing the drawer, then clicking Add to
      // Cart would slip an extra unit past the (now stale) cache in the ATC fast-path.
      const proceedAndSync = () => originalFetch(url, options).then(response => {
        response.clone().json().then(cart => {
          if (cart && cart.items) {
            cachedCart = cart;
            applyUI(cart);
            document.dispatchEvent(new CustomEvent('cart:updated'));
          }
        }).catch(() => {});
        return response;
      });

      // Optional total cap on increases
      const checkAndProceed = (cart) => {
        if (!ENFORCE_TOTAL) return proceedAndSync();
        const total = hatTotal(cart);
        const thisItem = cart.items.find(i => i.key === body.id || i.key === body.key);
        const currentQty = (thisItem && thisItem.quantity) || 0;
        const diff = (body.quantity || 0) - currentQty;
        if (total + diff > MAX_TOTAL) {
          showToast(`Max ${MAX_TOTAL} hats total.`);
          return Promise.resolve(new Response(JSON.stringify(cart), { status: 200, headers: { 'Content-Type': 'application/json' } }));
        }
        return proceedAndSync();
      };

      if (cachedCart) return checkAndProceed(cachedCart);
      return originalFetch('/cart.js').then(r => r.json()).then(cart => { cachedCart = cart; return checkAndProceed(cart); });
    }

    return originalFetch(url, options);
  };

  // ─── INTERCEPT XMLHttpRequest (some Dawn paths use XHR) ───
  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...args) {
    this._url = url;
    return originalOpen.apply(this, [method, url, ...args]);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (this._url && this._url.includes('/cart/change')) {
      let parsed = {};
      try {
        parsed = typeof body === 'string'
          ? (body.startsWith('{') ? JSON.parse(body) : Object.fromEntries(new URLSearchParams(body)))
          : {};
      } catch (e) {}

      if (parsed.quantity === 0) return originalSend.apply(this, arguments);

      const items = (cachedCart && cachedCart.items) || [];
      const item = (parsed.line && items[parsed.line - 1]) || items.find(i => i.key === parsed.id || i.key === parsed.key) || null;
      const lineMax = item ? maxFor(item) : MAX_PER_TYPE;
      if (parsed.quantity > lineMax) {
        showToast(lineMax === 1 ? 'Only 1 bundle allowed.' : `Only ${MAX_PER_TYPE} per hat style allowed.`);
        enforceCartRules(() => { document.dispatchEvent(new CustomEvent('cart:updated')); });
        return;
      }
      // Proceeding — refresh cachedCart once the change lands so the ATC fast-path stays accurate.
      this.addEventListener('load', () => { enforceCartRules(); }, { once: true });
    }
    return originalSend.apply(this, arguments);
  };

  // ─── UI ───
  function updateAllUI(cartData) {
    if (cartData) { cachedCart = cartData; applyUI(cartData); }
    else if (cachedCart) { applyUI(cachedCart); }
    else { originalFetch('/cart.js').then(r => r.json()).then(cart => { cachedCart = cart; applyUI(cart); }); }
  }

  function applyUI(cart) {
    disablePlusButtons(cart);
    disableAddToCartBtn(cart);
    updateCartCount(cart.item_count);
    injectBadgeStyles();  // always present (incl. empty-cart button fix)
    injectPdpNotice();    // PDP-only notice; card badges intentionally not shown
  }

  // ─── "LIMIT N" BADGES (cards) + "LIMIT N PER CUSTOMER" notice (PDP) ───
  function limitForHandle(handle) {
    return handle === BUNDLE_HANDLE ? 1 : MAX_PER_TYPE;
  }

  function handleFromHref(href) {
    const m = href && href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function injectBadgeStyles() {
    if (document.getElementById('hat-limit-badge-style')) return;
    const s = document.createElement('style');
    s.id = 'hat-limit-badge-style';
    s.textContent = `
      .hat-limit-badge {
        position: absolute; top: 10px; left: 10px; z-index: 4;
        background: #111; color: #fff; font-size: 11px; font-weight: 700;
        letter-spacing: 0.08em; text-transform: uppercase; padding: 5px 9px;
        border-radius: 4px; border: 1px solid rgba(255,255,255,0.25);
        line-height: 1; pointer-events: none;
      }
      .hat-limit-notice {
        display: inline-flex; align-items: center; gap: 6px; margin: 12px 0;
        font-size: 12px; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase;
        color: inherit;
      }
      /* Fix: theme's empty-cart-drawer "Continue shopping" button renders black-on-black */
      .cart-drawer__empty-content .button,
      .drawer__inner-empty .button {
        color: #fff !important;
        -webkit-text-fill-color: #fff !important;
      }
      /* Fix: cart-count number rendering invisible (white-on-white / text-fill override) */
      #cart-icon-bubble .cart-count-bubble,
      .cart-count-bubble,
      .cart-count-bubble span {
        color: #000 !important;
        -webkit-text-fill-color: #000 !important;
      }
    `;
    document.head.appendChild(s);
  }

  function injectCardBadges() {
    injectBadgeStyles();
    document.querySelectorAll('.card-wrapper').forEach(wrap => {
      if (wrap.querySelector('.hat-limit-badge')) return;
      const link = wrap.querySelector('a[href*="/products/"]');
      const handle = link && handleFromHref(link.getAttribute('href'));
      if (!handle) return;
      const host = wrap.querySelector('.card__inner') || wrap.querySelector('.card__media') || wrap;
      if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
      const badge = document.createElement('span');
      badge.className = 'hat-limit-badge';
      badge.textContent = 'Limit ' + limitForHandle(handle);
      host.appendChild(badge);
    });
  }

  function injectPdpNotice() {
    const handle = getPageHandle();
    if (!handle) return;
    if (document.querySelector('.hat-limit-notice')) return;
    injectBadgeStyles();
    const anchor = document.querySelector('.product-form__buttons')
      || document.querySelector('product-form')
      || document.querySelector('.product-form');
    if (!anchor || !anchor.parentNode) return;
    const notice = document.createElement('div');
    notice.className = 'hat-limit-notice';
    notice.textContent = '🔒 Limit ' + limitForHandle(handle) + ' per customer';
    anchor.parentNode.insertBefore(notice, anchor);
  }

  function disablePlusButtons(cart) {
    setTimeout(() => {
      // Dawn's qty +/- buttons + input carry data-index (1-based line index) — map to the cart line
      document.querySelectorAll('.quantity__button[name="plus"], button[name="plus"], [data-quantity-plus]').forEach(btn => {
        const idx = parseInt(btn.dataset.index, 10);
        let item = (idx && cart.items[idx - 1]) ? cart.items[idx - 1] : null;
        if (!item) {
          const lineItem = btn.closest('[data-cart-item], [data-key], [data-variant-id], tr, li');
          if (lineItem) {
            const key = lineItem.dataset.key || lineItem.dataset.cartItem;
            const variantId = lineItem.dataset.variantId;
            item = cart.items.find(i => (key && i.key === key) || (variantId && String(i.variant_id) === String(variantId)));
          }
        }
        if (!item) return; // can't map this button to a line — leave it alone
        const atMax = item.quantity >= maxFor(item);
        btn.disabled = atMax;
        btn.style.opacity = atMax ? '0.35' : '';
        btn.style.cursor = atMax ? 'not-allowed' : '';
        btn.style.pointerEvents = atMax ? 'none' : '';
        btn.title = atMax ? `Max ${maxFor(item)} ${item.handle === BUNDLE_HANDLE ? '(bundle)' : 'per hat'}` : '';
      });
      // Cap the qty input's max attribute too
      document.querySelectorAll('.quantity__input[data-index], input[name="quantity"][data-index]').forEach(input => {
        const idx = parseInt(input.dataset.index, 10);
        const item = idx && cart.items[idx - 1];
        if (item) input.max = String(maxFor(item));
      });
    }, 120);
  }

  function disableAddToCartBtn(cart) {
    const addBtnSelectors = [
      'button[name="add"]',
      '#AddToCart',
      '.product-form__cart-submit',
      '[data-type="add-to-cart-btn"]',
      'button[data-add-to-cart]'
    ];

    if (!document.getElementById('hat-btn-tooltip-style')) {
      const style = document.createElement('style');
      style.id = 'hat-btn-tooltip-style';
      style.textContent = `
        .hat-btn-wrapper { position: relative; display: inline-block; width: 100%; }
        .hat-btn-wrapper .hat-tooltip {
          visibility: hidden; opacity: 0; background: rgba(0,0,0,0.85); color: #fff;
          font-size: 12px; font-weight: 500; letter-spacing: 0.5px; text-align: center;
          padding: 7px 14px; border-radius: 6px; border: 1px solid rgba(255,255,255,0.15);
          position: absolute; bottom: calc(100% + 10px); left: 50%; transform: translateX(-50%);
          white-space: nowrap; z-index: 9999; transition: opacity 0.2s ease; pointer-events: none; }
        .hat-btn-wrapper .hat-tooltip::after {
          content: ''; position: absolute; top: 100%; left: 50%; transform: translateX(-50%);
          border: 5px solid transparent; border-top-color: rgba(0,0,0,0.85); }
        .hat-btn-wrapper:hover .hat-tooltip { visibility: visible; opacity: 1; }
      `;
      document.head.appendChild(style);
    }

    const pageHandle = getPageHandle();
    const isBundle = pageHandle === BUNDLE_HANDLE;
    const perTypeMax = isBundle ? 1 : MAX_PER_TYPE;
    const currentQty = getQtyInCart(cart, getProductIdFromPage());

    addBtnSelectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(btn => {
        const atLimit = currentQty >= perTypeMax && currentQty > 0;
        const cartFull = ENFORCE_TOTAL && !isBundle && hatTotal(cart) >= MAX_TOTAL;

        if (atLimit || cartFull) {
          if (!btn.parentElement.classList.contains('hat-btn-wrapper')) {
            const wrapper = document.createElement('div');
            wrapper.className = 'hat-btn-wrapper';
            const tooltip = document.createElement('span');
            tooltip.className = 'hat-tooltip';
            tooltip.textContent = atLimit
              ? (isBundle ? '🔒 Bundle already in your cart' : `🔒 Max ${MAX_PER_TYPE} of this hat already in your cart`)
              : `🔒 Cart full (${MAX_TOTAL} hats max)`;
            btn.parentNode.insertBefore(wrapper, btn);
            wrapper.appendChild(btn);
            wrapper.appendChild(tooltip);
          }
          btn.disabled = true;
          btn.style.opacity = '0.45';
          btn.style.cursor = 'not-allowed';
          btn.style.pointerEvents = 'none';
          btn.parentElement.style.pointerEvents = 'auto';
          btn.parentElement.style.cursor = 'not-allowed';
        } else {
          if (btn.parentElement.classList.contains('hat-btn-wrapper')) {
            const wrapper = btn.parentElement;
            wrapper.parentNode.insertBefore(btn, wrapper);
            wrapper.remove();
          }
          btn.disabled = false;
          btn.style.opacity = '';
          btn.style.cursor = '';
          btn.style.pointerEvents = '';
        }
      });
    });
  }

  function getProductIdFromPage() {
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      return window.ShopifyAnalytics.meta.product.id;
    }
    return getPageHandle();
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count-bubble span, .cart-count, [data-cart-count]').forEach(el => {
      el.textContent = count;
    });
  }

  function showToast(msg) {
    let toast = document.getElementById('hat-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'hat-cart-toast';
      toast.style.cssText = `position: fixed; bottom: 30px; left: 50%; transform: translateX(-50%);
        background: #111; color: #fff; padding: 14px 28px; border-radius: 10px; font-size: 14px;
        font-weight: 600; z-index: 99999; box-shadow: 0 6px 30px rgba(0,0,0,0.5);
        border: 1px solid rgba(255,255,255,0.2); transition: opacity 0.4s ease; white-space: nowrap;`;
      document.body.appendChild(toast);
    }
    toast.textContent = '🧢 ' + msg;
    toast.style.opacity = '1';
    clearTimeout(toast._t);
    toast._t = setTimeout(() => { toast.style.opacity = '0'; }, 3000);
  }

  // ─── OBSERVE DOM (debounced) ───
  let observerTimeout = null;
  const observer = new MutationObserver(() => {
    clearTimeout(observerTimeout);
    observerTimeout = setTimeout(() => {
      if (cachedCart) applyUI(cachedCart); else updateAllUI();
    }, 300);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // ─── INIT ───
  function boot() {
    // Paint the PDP limit notice instantly — it only needs the page handle, NOT the cart.
    // (Previously it only ran inside applyUI() after the /cart.js fetch resolved → ~2s delay.)
    injectBadgeStyles();
    injectPdpNotice();
    // Cart-dependent UI (qty steppers, button-disable, count) can wait for /cart.js.
    enforceCartRules();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('cart:updated', () => updateAllUI());
})();
